module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis3-6e650e290d4d16669121e48e03398e23.jpg";